import { TextInput } from '@volkswagen-onehub/components-core';
import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${(props) => props.theme.size.static200};

  .icon-wrapper {
    margin-bottom: 4px;
  }
`;

export interface DetailProps {
  icon?: ReactNode;
  text: string;
  value: string | number;
}

export function Detail({ icon, text, value }: DetailProps): ReactElement | null {
  return value ? (
    <StyledContainer>
      <div className="icon-wrapper">{icon}</div>
      <TextInput label={text} defaultValue={value.toString()} appearance="readonly" isFloating />
    </StyledContainer>
  ) : null;
}
